var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: {
        "max-width": "600",
        "retain-focus": false,
        persistent: "",
        "hide-overlay": "",
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c("v-card", { staticClass: "primary pa-4" }, [
        _c(
          "div",
          {
            staticClass:
              "primary navy--text text--darken-1 pt-2 px-2 d-flex align-center font-hemi-head",
          },
          [
            _c("v-icon", { staticClass: "white--text", attrs: { left: "" } }, [
              _vm._v("design_services"),
            ]),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "white--text",
                staticStyle: { "font-size": "18px" },
              },
              [
                _vm._v("PIANIFICAZIONE CREDITI "),
                _c("br"),
                _vm._v("(Ex Asta-Manager)"),
              ]
            ),
            _vm._v(" "),
            _c("v-spacer"),
            _vm._v(" "),
            _c(
              "v-btn",
              {
                attrs: { depressed: "", icon: "" },
                on: {
                  click: function ($event) {
                    return _vm.dismiss()
                  },
                },
              },
              [_c("v-icon", [_vm._v("close")])],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pa-4 white--text" },
          [
            _c(
              "v-expansion-panels",
              { attrs: { flat: "", tile: "", value: [1] } },
              [
                _c(
                  "v-expansion-panel",
                  [
                    _c(
                      "v-expansion-panel-header",
                      {
                        staticClass: "font-hemi-head",
                        scopedSlots: _vm._u([
                          {
                            key: "actions",
                            fn: function () {
                              return [
                                _c("v-icon", { staticClass: "text--white" }, [
                                  _vm._v("fa-caret-down "),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                      },
                      [_vm._v("\n            COME FUNZIONA\n            ")]
                    ),
                    _vm._v(" "),
                    _c("v-expansion-panel-content", [
                      _c("div", [
                        _c(
                          "div",
                          { staticClass: "pt-2 navy--text text--darken-2" },
                          [_c("b", [_vm._v("A cosa serve?")])]
                        ),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            "\n                La pianificazione dei crediti prima dell'asta e il fatto che\n                Asta Live ti aiuta a aggiornarla in tempo reale è uno\n                strumento di grandissimo aiuto per non cadere nel tipico\n                errore di spendere troppo per qualche calciatore durante le\n                concitate fasi d'asta e rimanere quindi poi con pochi crediti\n                per completare la rosa. Col risultato finale di avere una\n                squadra non equilibrata.\n              "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "pt-2 navy--text text--darken-2" },
                          [_c("b", [_vm._v("Cosa devi fare?")])]
                        ),
                        _vm._v(" "),
                        _c("ul", [
                          _c("li", [
                            _vm._v(
                              "\n                  Pianifica quanti crediti vorresti spendere per ciascuno\n                  slot.\n                "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm._v(
                              "\n                  (Opzionale) Pianifica lista obiettivi (nomi calciatori) per\n                  ciascuno slot.\n                "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "pt-2 navy--text text--darken-2" },
                          [_c("b", [_vm._v("E poi?")])]
                        ),
                        _vm._v(
                          "\n              Durante l'asta man mano che acquisti calciatori:\n              "
                        ),
                        _c("ul", [
                          _c("li", [
                            _vm._v(
                              '\n                  Asta Live "inserisce" in automatico il calciatore comprato\n                  nello slot adeguato (sostituendo i crediti pianificati con\n                  quelli effettivamente spesi)\n                '
                            ),
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm._v(
                              "\n                  Se hai speso di più o di meno di quanto pianificato per\n                  quello slot, Asta Live ti avvisa quanti crediti devi\n                  ridistribuire tra gli slot liberi rimanenti\n                "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm._v(
                              "\n                  Rimuove automaticamente dalla tua lista gli obiettivi non\n                  più disponibili\n                "
                            ),
                          ]),
                        ]),
                      ]),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm.asta_info.lega.nRuoli.op == "illimitati"
              ? _c("div", { staticClass: "d-flex flex-column pt-4" }, [
                  _c("div", [
                    _c("div", { staticClass: "navy--text text--darken-2" }, [
                      _c("b", [_vm._v("Numero calciatori")]),
                    ]),
                    _vm._v(
                      '\n          In questa lega ci sono acquisti "illimitati / a piacere". Per poter\n          procedere a una pianificazione devi innanzitutto impostare quanti\n          calciatori intendi acquistare per ciascun ruolo\n        '
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "d-flex align-center" },
                    [
                      _c("v-select", {
                        staticClass: "ma-1",
                        class: { invalido: !_vm.nP_items.includes(_vm.nP) },
                        attrs: {
                          items: _vm.nP_items,
                          label: "P",
                          required: "",
                          solo: "",
                          flat: "",
                          dense: "",
                          "hide-details": "",
                        },
                        model: {
                          value: _vm.nP,
                          callback: function ($$v) {
                            _vm.nP = $$v
                          },
                          expression: "nP",
                        },
                      }),
                      _vm._v(" "),
                      _c("v-select", {
                        staticClass: "ma-1",
                        class: { invalido: !_vm.nD_items.includes(_vm.nD) },
                        attrs: {
                          items: _vm.nD_items,
                          label: "D",
                          required: "",
                          solo: "",
                          flat: "",
                          dense: "",
                          "hide-details": "",
                        },
                        model: {
                          value: _vm.nD,
                          callback: function ($$v) {
                            _vm.nD = $$v
                          },
                          expression: "nD",
                        },
                      }),
                      _vm._v(" "),
                      _c("v-select", {
                        staticClass: "ma-1",
                        class: { invalido: !_vm.nC_items.includes(_vm.nC) },
                        attrs: {
                          items: _vm.nC_items,
                          label: "C",
                          required: "",
                          solo: "",
                          flat: "",
                          dense: "",
                          "hide-details": "",
                        },
                        model: {
                          value: _vm.nC,
                          callback: function ($$v) {
                            _vm.nC = $$v
                          },
                          expression: "nC",
                        },
                      }),
                      _vm._v(" "),
                      _c("v-select", {
                        staticClass: "ma-1",
                        class: { invalido: !_vm.nA_items.includes(_vm.nA) },
                        attrs: {
                          items: _vm.nA_items,
                          label: "A",
                          required: "",
                          solo: "",
                          flat: "",
                          dense: "",
                          "hide-details": "",
                        },
                        model: {
                          value: _vm.nA,
                          callback: function ($$v) {
                            _vm.nA = $$v
                          },
                          expression: "nA",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.mantra
                    ? _c(
                        "div",
                        [
                          _c("v-icon", { attrs: { left: "" } }, [
                            _vm._v("warning"),
                          ]),
                          _vm._v(
                            " Sebbene sia una lega a Mantra, per la\n          pianificazione dei ruoli da acquistare si fa riferimento ai ruoli\n          "
                          ),
                          _c("b", [_vm._v("classici")]),
                          _vm._v(
                            " (identificabili dal bordo sinistro del rettangolo\n          intorno al calciatore)\n        "
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "d-flex flex-column pt-4" }, [
              _c("div", {}, [
                _c("div", { staticClass: "navy--text text--darken-2" }, [
                  _c("b", [_vm._v("Inizializza distribuzione crediti")]),
                ]),
                _vm._v(
                  "\n          Per velocizzare la pianificazione iniziale dei crediti, scegli lo\n          schema che vorresti utilizzare e Asta Live distribuirà i crediti tra\n          i vari slot adeguatamente. Ovviamente potrai sempre modificare la\n          distribuzione anche manualmente.\n        "
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "py-4" },
                [
                  _c("v-select", {
                    attrs: {
                      items: _vm.strategieOptions,
                      label: "Scegli schema",
                      solo: "",
                      flat: "",
                      "hide-details": "",
                    },
                    on: { change: _vm.strategiaChanged },
                    model: {
                      value: _vm.strategiaModel,
                      callback: function ($$v) {
                        _vm.strategiaModel = $$v
                      },
                      expression: "strategiaModel",
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "pt-4" },
              [
                _c("div", { staticClass: "navy--text text--darken-2" }, [
                  _c("b", [_vm._v("Criterio scelta slot")]),
                ]),
                _vm._v(
                  '\n\n        - Quando acquisti un calciatore presente nella "Lista Obiettivi", Asta\n        Live lo inserisce automaticamente nel relativo slot.'
                ),
                _c("br"),
                _vm._v(
                  '\n        - Quando invece acquisti un calciatore che non hai messo nella "Lista\n        Obiettivi", in quale slot deve inserirlo Asta Live?\n        '
                ),
                _c("v-select", {
                  staticClass: "py-4",
                  attrs: {
                    items: _vm.getAssociazioneMethodSelectOptions(),
                    solo: "",
                    flat: "",
                  },
                  model: {
                    value: _vm.associazioneMethod,
                    callback: function ($$v) {
                      _vm.associazioneMethod = $$v
                    },
                    expression: "associazioneMethod",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-expansion-panels",
              { attrs: { flat: "", tile: "" } },
              [
                _c(
                  "v-expansion-panel",
                  [
                    _c(
                      "v-expansion-panel-header",
                      {
                        staticClass: "font-hemi-head",
                        scopedSlots: _vm._u([
                          {
                            key: "actions",
                            fn: function () {
                              return [
                                _c("v-icon", { staticClass: "text--white" }, [
                                  _vm._v("fa-caret-down "),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                      },
                      [
                        _vm._v(
                          "\n            FAQ / Domande frequenti\n            "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("v-expansion-panel-content", [
                      _c("div", [
                        _c(
                          "div",
                          { staticClass: "pt-2 navy--text text--darken-2" },
                          [
                            _c("b", [
                              _vm._v(
                                "Perchè sono scomparsi dei calciatori dalla mia lista\n                  obiettivi?"
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            "\n                Perchè non sono più disponibili tra gli svincolati: o sono\n                stati acquistati (da qualcun altro o da te), o sono stati\n                scartati, o non giocano più nel campionato\n              "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "pt-2 navy--text text--darken-2" },
                          [
                            _c("b", [
                              _vm._v(
                                "Con che logica Asta Live sceglie in quale slot inserire il\n                  calciatore appena acquistato?"
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            '\n                Asta Live inizialmente cerca il primo slot libero in cui\n                eventualmente quel calciatore compare come obiettivo. Se non\n                lo trova o lo mette nel primo slot disponibile o chiede a te\n                con un popup non appena acquistato (dipende dalla tua scelta\n                nell\'opzione "Criterio scelta slot")\n              '
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "pt-2 navy--text text--darken-2" },
                          [
                            _c("b", [
                              _vm._v(
                                "Asta Live mi ha inserito un calciatore acquistato in un\n                  certo slot ma io vorrei inserirlo in un altro"
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            "\n                Non c'è problema. Puoi toglierlo dallo slot (premendo sulla X\n                accanto al nome) e inserirlo in un altro slot (premendo sul\n                numero dello slot stesso)\n              "
                          ),
                        ]),
                      ]),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }